<template>
  <div class="content-top-padding initiatives holidayAtHome" v-cloak>
    <InitNav />

    <div class="container-fluid banner p-0 mb-5">
      <img
        alt=""
        src="@/assets/initiatives/holidayAtHome/banner01_holidayathome-c.jpg"
        class="d-none d-md-block"
        v-if="$i18n.locale == 'zh'"
      />
      <img
        alt=""
        src="@/assets/initiatives/holidayAtHome/banner01_holidayathome-e.jpg"
        class="d-none d-md-block"
        v-else
      />
      <img
        alt=""
        src="@/assets/initiatives/holidayAtHome/m_banner01_holidayathome-c.jpg"
        class="d-block d-md-none"
        v-if="$i18n.locale == 'zh'"
      />
      <img
        alt=""
        src="@/assets/initiatives/holidayAtHome/m_banner01_holidayathome-e.jpg"
        class="d-block d-md-none"
        v-else
      />
    </div>

    <div class="container">
      <CustomBreadcrumb holiday />

      <div
        class="
          row
          routing
          d-flex
          justify-content-between
          align-items-center
          mb-5
        "
      >
        <div class="col main-theme d-flex flex-row align-items-center">
          <router-link :to="{ name: 'Initiatives' }" class="">
            <img class="mr-2 route-arrow" src="@/assets/01/btn_catalog_arrow_l.svg" />
          </router-link>
          <router-link :to="{ name: 'Initiatives' }" class="">
            {{ $t("title.init") }}
          </router-link>
        </div>
        <div class="col main-theme d-flex justify-content-end text-right align-items-center">
          <router-link :to="{ name: 'GlobalVisibility-MissYouToo' }" class="">
            {{ $t("title.gv") }}
          </router-link>
          <router-link :to="{ name: 'GlobalVisibility-MissYouToo' }" class="">
            <img class="ml-2 route-arrow" src="@/assets/01/btn_catalog_arrow_r.svg" />
          </router-link>
        </div>
      </div>

      <div class="row intro mb-5 pb-5">
        <div class="col-12 text-uppercase main-theme mb-3">
          <h3 class="font-weight-bold">{{ $t("title.holiday") }}</h3>
        </div>
        <div class="col-md-12 col-lg-6 mb-5 mb-sm-5 mb-lg-0">
          <CustomCarousel
            carouselID="holiday-intro"
            aspectRatio="16:9"
            :slides="preview.intro"
            :lightboxARR="lightbox.intro"
          />
        </div>
        <div class="col-md-12 col-lg-6 text-theme" v-if="$i18n.locale == 'zh'">
          鑑於疫情不斷變化，旅發局首度推出「旅遊 ‧
          就在香港」推廣計劃，鼓勵市民「做自己的旅客」，重新發掘香港的旅遊特色，營造正面的氣氛，刺激本地消費。這個前所未有的計劃在2021年香港管理專業協會「傑出市場策劃獎」中獲頒銅獎及傑出危機應變及管理獎，並且在INMA全球媒體大獎2021「原生廣告」組別中，勇奪優異獎。
        </div>
        <div class="col-md-12 col-lg-6 text-theme" v-else>
          In light of the evolving pandemic situation, the HKTB has launched a first-of-its-kind
          promotion “Holiday at Home”. The campaign encourages local Hong Kong people to be “our own
          tourists” and rediscover the tourism appeal of the city, and ultimate ly creates a
          positive ambience and boosts local consumption. This unprecedented approach of the HKTB
          has made it a top 10 finalists in the 2021 Hong Kong Management Association (HKMA) Awards
          for Marketing Excellence and won an honourable mentions in the “Native Advertising”
          category of the INMA Global Media Awards 2021.
        </div>
      </div>

      <div class="row page-header mb-5">
        <div class="col-12 main-theme text-center mb-4">
          <h3>
            {{ $t("holiday.intro") }}
          </h3>
        </div>
        <div class="col-12 text-theme" v-if="$i18n.locale == 'zh'">
          為了帶動本地旅遊氣氛及促進本地消費，旅發局透過「旅遊‧就在香港」的平台，推出了三輪「賞你遊」及「賞你住」活動，以鼓勵本地消費者支持城中商戶，在消費鏈中製造乘數效應，推動跨行業的協同效益。
        </div>
        <div class="col-12 text-theme" v-else>
          To stimulate local tourism atmosphere and boost local spending, the campaign launched 3
          rounds of Spend-to-Redeem activities to provide incentives to local consumers to support
          businesses in town, generating a multiplying effect along the consumption chain and
          fostering cross-sector synergy.
        </div>
      </div>

      <div class="row left-carou One-Stop mb-5">
        <CoolLightBox
          :items="lightbox.stRowZh"
          :index="index"
          @close="index = null"
          :effect="'fade'"
          v-if="$i18n.locale == 'zh'"
        >
        </CoolLightBox>
        <CoolLightBox
          :items="lightbox.stRow"
          :index="index"
          @close="index = null"
          :effect="'fade'"
          v-else
        >
        </CoolLightBox>
        <div class="col-lg-6 mb-5 mb-lg-0">
          <b-carousel id="carousel-1" class="carou-slide" controls v-if="$i18n.locale == 'zh'">
            <b-carousel-slide>
              <template #img>
                <img
                  @click="index = 0"
                  class="d-block img-fluid w-100"
                  src="@/assets/initiatives/holidayAtHome/4-1-1-1-preview-websitelanding-c.jpg"
                  alt="image slot"
                />
              </template>
            </b-carousel-slide>
            <b-carousel-slide>
              <template #img>
                <img
                  @click="index = 1"
                  class="d-block img-fluid w-100"
                  src="@/assets/initiatives/holidayAtHome/4-1-1-2-preview-hoteloffer-conrad-c.jpg"
                  alt="image slot"
                />
              </template>
            </b-carousel-slide>
          </b-carousel>
          <b-carousel id="carousel-1" class="carou-slide" controls v-else>
            <b-carousel-slide>
              <template #img>
                <img
                  @click="index = 0"
                  class="d-block img-fluid w-100"
                  src="@/assets/initiatives/holidayAtHome/4-1-1-1-preview-websitelanding-e.jpg"
                  alt="image slot"
                />
              </template>
            </b-carousel-slide>
            <b-carousel-slide>
              <template #img>
                <img
                  @click="index = 1"
                  class="d-block img-fluid w-100"
                  src="@/assets/initiatives/holidayAtHome/4-1-1-2-preview-hoteloffer-conrad-e.jpg"
                  alt="image slot"
                />
              </template>
            </b-carousel-slide>
          </b-carousel>
        </div>
        <div class="col-lg-6">
          <div class="main-theme mb-4">
            <h4>{{ $t("holiday.oneStop.heading") }}</h4>
          </div>
          <div class="text-theme" v-html="$t('holiday.oneStop.text')"></div>
        </div>
      </div>

      <div class="row right-carou In-depth mb-5">
        <CoolLightBox
          :items="lightbox.ndRowZh"
          :index="index2"
          @close="index2 = null"
          :effect="'fade'"
          v-if="$i18n.locale == 'zh'"
        >
        </CoolLightBox>
        <CoolLightBox
          :items="lightbox.ndRow"
          :index="index2"
          @close="index2 = null"
          :effect="'fade'"
          v-else
        >
        </CoolLightBox>
        <div class="order-1 order-lg-0 col-lg-6">
          <div class="main-theme mb-4">
            <h4>{{ $t("holiday.inDepth.heading") }}</h4>
          </div>
          <div class="text-theme" v-html="$t('holiday.inDepth.text')"></div>
        </div>
        <div class="order-0 order-lg-1 mb-5 mb-lg-0 col-lg-6">
          <b-carousel id="carousel-2" class="carou-slide" controls v-if="$i18n.locale == 'zh'">
            <b-carousel-slide>
              <template #img>
                <b-aspect aspect="16:9" class="d-flex align-items-center">
                  <img
                    @click="index2 = 0"
                    class="d-block img-fluid w-100"
                    src="@/assets/initiatives/holidayAtHome/4-1-2-1-preview-hk-60s.jpg"
                    alt="image slot"
                  />
                </b-aspect>
              </template>
            </b-carousel-slide>
            <b-carousel-slide>
              <template #img>
                <b-aspect aspect="16:9" class="d-flex align-items-center">
                  <img
                    @click="index2 = 1"
                    class="d-block img-fluid w-100"
                    src="@/assets/initiatives/holidayAtHome/4-1-2-2-preview-routemap-c.jpg"
                    alt="image slot"
                  />
                </b-aspect>
              </template>
            </b-carousel-slide>
            <b-carousel-slide>
              <template #img>
                <b-aspect aspect="16:9" class="d-flex">
                  <img
                    @click="index2 = 2"
                    class="d-block img-fluid w-100"
                    src="@/assets/initiatives/holidayAtHome/4-1-2-3-preview-shoppingfiesta-c.jpg"
                    alt="image slot"
                  />
                </b-aspect>
              </template>
            </b-carousel-slide>
            <b-carousel-slide>
              <template #img>
                <b-aspect aspect="16:9" class="d-flex">
                  <img
                    @click="index2 = 3"
                    class="d-block img-fluid w-100"
                    src="@/assets/initiatives/holidayAtHome/4-1-2-5-preview-gastrofantasies-c.jpg"
                    alt="image slot"
                  />
                </b-aspect>
              </template>
            </b-carousel-slide>
          </b-carousel>
          <b-carousel id="carousel-2" class="carou-slide" controls v-else>
            <b-carousel-slide>
              <template #img>
                <b-aspect aspect="16:9" class="d-flex align-items-center">
                  <img
                    @click="index2 = 0"
                    class="d-block img-fluid w-100"
                    src="@/assets/initiatives/holidayAtHome/4-1-2-1-preview-hk-60s.jpg"
                    alt="image slot"
                  />
                </b-aspect>
              </template>
            </b-carousel-slide>
            <b-carousel-slide>
              <template #img>
                <b-aspect aspect="16:9" class="d-flex align-items-center">
                  <img
                    @click="index2 = 1"
                    class="d-block img-fluid w-100"
                    src="@/assets/initiatives/holidayAtHome/4-1-2-2-preview-routemap-e.jpg"
                    alt="image slot"
                  />
                </b-aspect>
              </template>
            </b-carousel-slide>
            <b-carousel-slide>
              <template #img>
                <b-aspect aspect="16:9" class="d-flex">
                  <img
                    @click="index2 = 2"
                    class="d-block img-fluid w-100"
                    src="@/assets/initiatives/holidayAtHome/4-1-2-3-preview-shoppingfiesta-E.jpg"
                    alt="image slot"
                  />
                </b-aspect>
              </template>
            </b-carousel-slide>
            <b-carousel-slide>
              <template #img>
                <b-aspect aspect="16:9" class="d-flex">
                  <img
                    @click="index2 = 3"
                    class="d-block img-fluid w-100"
                    src="@/assets/initiatives/holidayAtHome/4-1-2-5-preview-gastrofantasies-e.jpg"
                    alt="image slot"
                  />
                </b-aspect>
              </template>
            </b-carousel-slide>
          </b-carousel>
        </div>
      </div>

      <div class="row left-carou Spend-to-Redeem mb-5">
        <CoolLightBox
          :items="lightbox.rdRowZh"
          :index="index3"
          @close="index3 = null"
          :effect="'fade'"
          v-if="$i18n.locale == 'zh'"
        >
        </CoolLightBox>
        <CoolLightBox
          :items="lightbox.rdRow"
          :index="index3"
          @close="index3 = null"
          :effect="'fade'"
          v-else
        >
        </CoolLightBox>
        <div class="col-lg-6 mb-5 mb-lg-0">
          <b-carousel
            id="carousel-3"
            class="carou-slide"
            controls
            v-if="$i18n.locale == 'zh'"
          >
            <b-carousel-slide>
              <template #img>
                <b-aspect aspect="4:3" class="d-flex align-items-center">
                  <img
                    @click="index3 = 0"
                    class="d-block img-fluid w-100"
                    src="@/assets/initiatives/holidayAtHome/4-1-3-1-preview-freetour-c.jpg"
                    alt="image slot"
                  />
                </b-aspect>
              </template>
            </b-carousel-slide>
            <b-carousel-slide>
              <template #img>
                <b-aspect aspect="4:3" class="d-flex align-items-center">
                  <img
                    @click="index3 = 1"
                    class="d-block img-fluid w-100"
                    src="@/assets/initiatives/holidayAtHome/4-1-3-2-preview-staycationdelights-c.jpg"
                    alt="image slot"
                  />
                </b-aspect>
              </template>
            </b-carousel-slide>
            <b-carousel-slide>
              <template #img>
                <b-aspect aspect="4:3" class="d-flex">
                  <img
                    @click="index3 = 2"
                    class="d-block img-fluid w-100"
                    src="@/assets/initiatives/holidayAtHome/4-1-3-3-preview-staycationoffers-c.jpg"
                    alt="image slot"
                  />
                </b-aspect>
              </template>
            </b-carousel-slide>
          </b-carousel>
          <b-carousel id="carousel-3" class="carou-slide" controls v-else>
            <b-carousel-slide>
              <template #img>
                <b-aspect aspect="4:3" class="d-flex align-items-center">
                  <img
                    @click="index3 = 0"
                    class="d-block img-fluid"
                    src="@/assets/initiatives/holidayAtHome/4-1-3-1-preview-e.jpg"
                    alt="image slot"
                  />
                </b-aspect>
              </template>
            </b-carousel-slide>
            <b-carousel-slide>
              <template #img>
                <b-aspect aspect="4:3" class="d-flex">
                  <img
                    @click="index3 = 1"
                    class="d-block img-fluid "
                    src="@/assets/initiatives/holidayAtHome/4-1-3-2-preview-e.jpg"
                    alt="image slot"
                  />
                </b-aspect>
              </template>
            </b-carousel-slide>
            <b-carousel-slide>
              <template #img>
                <b-aspect aspect="4:3" class="d-flex ">
                  <img
                    @click="index3 = 2"
                    class="d-block img-fluid "
                    src="@/assets/initiatives/holidayAtHome/4-1-3-3-preview-staycationoffers-e.jpg"
                    alt="image slot"
                  />
                </b-aspect>
              </template>
            </b-carousel-slide>
          </b-carousel>
        </div>
        <div class="col-lg-6">
          <div class="main-theme mb-4">
            <h4>{{ $t("holiday.spend.heading") }}</h4>
          </div>
          <div class="text-theme" v-html="$t('holiday.spend.text')"></div>
        </div>
      </div>

      <div class="row right-carou Eigh-Weeks mb-5">
        <CoolLightBox
          :items="lightbox.fourthRowZh"
          :index="index4"
          @close="index4 = null"
          :effect="'fade'"
          v-if="$i18n.locale == 'zh'"
        >
        </CoolLightBox>
        <CoolLightBox
          :items="lightbox.fourthRow"
          :index="index4"
          @close="index4 = null"
          :effect="'fade'"
          v-else
        >
        </CoolLightBox>
        <div class="order-1 order-lg-0 col-lg-6">
          <div class="main-theme mb-4">
            <h4>{{ $t("holiday.eight.heading") }}</h4>
          </div>
          <div class="text-theme mb-4" v-html="$t('holiday.eight.text')">></div>
          <div class="row">
            <div class="col-6 partner-icon">
              <img
                alt=""
                src="@/assets/initiatives/holidayAtHome/logo-openrice-tc.jpg"
                v-if="$i18n.locale == 'zh'"
              />
              <img alt="" src="@/assets/initiatives/holidayAtHome/logo-openrice-en.jpg" v-else />
            </div>
          </div>
        </div>
        <div class="order-0 order-lg-1 mb-5 mb-lg-0 col-lg-6">
          <b-carousel id="carousel-4" class="carou-slide" v-if="$i18n.locale == 'zh'">
            <b-carousel-slide>
              <template #img>
                <img
                  @click="index4 = 0"
                  class="d-block img-fluid w-100"
                  src="@/assets/initiatives/holidayAtHome/4-1-4-1-preview-c.jpg"
                  alt="image slot"
                />
              </template>
            </b-carousel-slide>
          </b-carousel>
          <b-carousel id="carousel-4" class="carou-slide" v-else>
            <b-carousel-slide>
              <template #img>
                <img
                  @click="index4 = 0"
                  class="d-block img-fluid w-100"
                  src="@/assets/initiatives/holidayAtHome/4-1-4-1-preview-e.jpg"
                  alt="image slot"
                />
              </template>
            </b-carousel-slide>
          </b-carousel>
        </div>
      </div>
    </div>

    <div class="container-fluid foot-note mb-5">
      <div class="container py-3">
        <div class="row">
          <div class="col">
            <div class="title my-3" v-if="$i18n.locale == 'zh'">
              <h3>「旅遊 ‧ 就在香港」：重點數字</h3>
            </div>
            <div class="title my-3" v-else><h3>“Holiday at Home” in numbers</h3></div>
            <div class="dot-points text-theme" v-if="$i18n.locale == 'zh'">
              <ul>
                <li>
                  「旅遊 ‧ 就在香港」專題網站︰逾400萬瀏覽人次
                </li>
                <li>
                  主題路線︰共15條，涵蓋120個景點
                </li>
                <li>
                  「Hello! Hong Kong」趣聞影片︰觀看及互動次數超過845,000次
                </li>
                <li>
                  第一輪「賞你遊」活動︰45間旅行社提供45條深度遊路線，於5日內爆滿，帶來1,200萬港元的本地消費額
                </li>
                <li>
                  「賞你住」活動︰帶來2,800萬港元的本地消費，惠及約140間參與酒店，房間入住數目約2萬次，為參與酒店帶來近2,500萬港元營業收入
                </li>
                <li>
                  「OpenRice x
                  旅發局『嚐．饌賞』」︰為超過200間「優質旅遊服務」計劃認可的食肆帶來至少100萬港元收入
                </li>
              </ul>
            </div>
            <div class="dot-points text-theme" v-else>
              <ul>
                <li>
                  “Holiday at Home” campaign website: over 4 million individual visits
                </li>
                <li>
                  Themed itineraries: 15 itineraries covering 120 points of interests
                </li>
                <li>
                  “Hello! Hong Kong” Fun Fact Videos: 850,000 views and engagement
                </li>
                <li>
                  Spend-to-Redeem “Free Tours” (first round): 45 immersive itineraries from 45
                  travel agencies, contributed to HK$12 million local consumptions, fully booked in
                  5 days
                </li>
                <li>
                  Spend-to-Redeem “Staycation Delights”: contributed to HK$28 million local
                  consumptions, benefitted about 140 hotels, driven round HK$25 million sales in
                  hotels, contributed to around 20,000 room occupancies
                </li>
                <li>
                  OpenRice x HKTB Meal-tual Fun: Generated at least HK$1 million patronage for more
                  than 200 QTS diners
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div
        class="
          row
          routing
          d-flex
          justify-content-between
          align-items-center
          mb-5
        "
      >
        <div class="col main-theme d-flex flex-row align-items-center">
          <router-link :to="{ name: 'Initiatives' }" class="">
            <img class="mr-2 route-arrow" src="@/assets/01/btn_catalog_arrow_l.svg" />
          </router-link>
          <router-link :to="{ name: 'Initiatives' }" class="">
            {{ $t("title.init") }}
          </router-link>
        </div>
        <div class="col main-theme d-flex justify-content-end text-right align-items-center">
          <router-link :to="{ name: 'GlobalVisibility-MissYouToo' }" class="">
            {{ $t("title.gv") }}
          </router-link>
          <router-link :to="{ name: 'GlobalVisibility-MissYouToo' }" class="">
            <img class="ml-2 route-arrow" src="@/assets/01/btn_catalog_arrow_r.svg" />
          </router-link>
        </div>
      </div>
    </div>
    <BackToTopBtn />
  </div>
</template>

<script>
import CustomCarousel from "@/components/CustomCarousel.vue";
import BackToTopBtn from "@/components/BackToTopBtn.vue";
import CoolLightBox from "vue-cool-lightbox";
import "vue-cool-lightbox/dist/vue-cool-lightbox.min.css";
import InitNav from "@/components/InitiativesNav.vue";
import CustomBreadcrumb from "@/components/CustomBreadcrumb.vue";

export default {
  name: "HolidayAtHome",
  components: {
    BackToTopBtn,
    CoolLightBox,
    InitNav,
    CustomBreadcrumb,
    CustomCarousel,
  },
  metaInfo: {
    title: "Holiday at Home",
    titleTemplate: "%s - HKTB Annual Report 2020/21",
  },
  data() {
    return {
      lightbox: {
        intro: ["initiatives/holiday/intro-1.jpg", "initiatives/holiday/intro-2.jpg"],
        stRowZh: [
          "initiatives/holiday/4-1-1-1-websitelanding-c.jpg",
          "initiatives/holiday/4-1-1-2-hoteloffer-conrad-c.jpg",
        ],
        stRow: [
          "initiatives/holiday/4-1-1-1-websitelanding-e.jpg",
          "initiatives/holiday/4-1-1-2-hoteloffer-conrad-e.jpg",
        ],
        ndRow: [
          {
            src:
              "https://players.brightcove.net/4875109325001/w9KYS3VVj_default/index.html?videoId=6286087867001",
            mediaType: "iframe",
          },
          "initiatives/holiday/4-1-2-2-routemap-e.jpg",
          "initiatives/holiday/4-1-2-3-shoppingfiesta-E.jpg",
          // "initiatives/holiday/4-1-2-4-amusementEverywhere-e.jpg",
          "initiatives/holiday/4-1-2-5-gastrofantasies-e.gif",
        ],
        ndRowZh: [
          {
            src:
              "https://players.brightcove.net/4875109325001/w9KYS3VVj_default/index.html?videoId=6286087370001",
            mediaType: "iframe",
          },
          "initiatives/holiday/4-1-2-2-routemap-c.jpg",
          "initiatives/holiday/4-1-2-3-shoppingfiesta-c.gif",
          // "initiatives/holiday/4-1-2-4-amusementEverywhere-e.jpg",
          "initiatives/holiday/4-1-2-5-gastrofantasies-c.gif",
        ],
        rdRow: [
          "initiatives/holiday/4-1-3-1-freetour-e.jpg",
          "initiatives/holiday/4-1-3-2-staycationdelights-e.jpg",
          "initiatives/holiday/4-1-3-3-staycationoffers-e.jpg",
        ],
        rdRowZh: [
          "initiatives/holiday/4-1-3-1-freetour-c.gif",
          "initiatives/holiday/4-1-3-2-staycationdelights-c.gif",
          "initiatives/holiday/4-1-3-3-staycationoffers-c.jpg",
        ],
        fourthRow: ["initiatives/holiday/4-1-4-1-Openrice-e.jpg"],
        fourthRowZh: ["initiatives/holiday/4-1-4-1-Openrice-c.jpg"],
      },
      preview: {
        intro: [
          {
            preview: "initiatives/holiday/preview/preview-intro-1.jpg",
          },
          {
            preview: "initiatives/holiday/preview/preview-intro-2.jpg",
          },
        ],
      },
      index: null,
      index2: null,
      index3: null,
      index4: null,
    };
  },
  mounted() {
    if (this.$i18n.locale == "zh") {
      let zh4 = document.querySelectorAll("h3, h4");
      for (let i = 0; i < zh4.length; i++) {
        zh4[i].style.fontWeight = "bold";
      }
    }
  },
};
</script>

<style lang="scss">
.holidayAtHome {
  #carousel-3 {
    // max-width: 460px;
  }
  .intro {
    img {
      width: auto;
    }
  }
}
</style>
